import React from "react";
import { createStyles, createTheme, CssBaseline, makeStyles, ThemeProvider } from "@material-ui/core";

const GlobalStyles = () => {
  makeStyles(() =>
    createStyles({
      "@global": {
        "*": {
          boxSizing: "border-box",
          margin: 0,
          padding: 0,
        },
        html: {
          "-webkit-font-smoothing": "antialiased",
          "-moz-osx-font-smoothing": "grayscale",
          height: "fit-content",
          width: "100%",
          overflowY: "scroll",
        },
        body: {
          height: "100%",
          width: "100%",
          backgroundColor: "#001229",
        },
        "#root": {
          height: "100%",
          width: "100%",
        },
        ".MuiButtonBase-root.Mui-disabled": {
          cursor: "not-allowed",
          pointerEvents: "all",
        },
      },
    })
  )();

  return null;
};

export default function ThemeWrapper(props) {
  const isDarkMode = true; // for future

  const theme = createTheme({
    palette: {
      type: isDarkMode ? "dark" : "light",
      background: {
        paper: isDarkMode ? "#001229" : "#FFFFFF",
        primary: isDarkMode ? "#001229" : "#FFFFFF",
        secondary: isDarkMode ? "#16243B" : "#FFFFFF",
        primaryGradient: "linear-gradient(100.42deg, #2C85EE 16.07%, #4FB5FF 79.2%)",
      },
      primary: { main: isDarkMode ? "#1998F4" : "#2C85EE" },
      secondary: { main: isDarkMode ? "#ffffffb3" : "#EE7565" },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
      },
    },
    overrides: {
      MuiButton: {
        root: {
          textTransform: "none",
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      {props.children}
    </ThemeProvider>
  );
}
